module.exports = __webpack_public_path__ + "static/media/block-1_bg.465042f2.jpg";